export function getSteamLink(icid) {
  const base = "https://store.steampowered.com/app/1064690/Danger_Crew";
  if (icid) {
    return base + `?icid=${icid}`
  }
  return base;
}